import { render, staticRenderFns } from "./Transportations.vue?vue&type=template&id=571f6b24&scoped=true&"
import script from "./Transportations.vue?vue&type=script&lang=js&"
export * from "./Transportations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571f6b24",
  null
  
)

export default component.exports